import { render, staticRenderFns } from "./LegalDocumentContent_SrB7xP.vue?vue&type=template&id=3df06046&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_SrB7xP.vue?vue&type=style&index=0&id=3df06046&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df06046",
  null
  
)

export default component.exports